import Authorization from './Authorizations'

export default Authorization
